import { GuardianExpoSection } from './GuardianExpoSubPageLayout'
import ScheduleDayTabs from './ScheduleDayTabs'

/**
 * 場次時間表區塊（tab 依日期切換，自動預選今天；表格式：場次／時間兩欄）
 * days: [{ year, month, date, weekday, sessions: [{ label, time }] }]
 */
export default function SessionScheduleSection({ titleBlack, titleRed, days, columnLabels, first = false, last = false }) {
  return (
    <GuardianExpoSection titleBlack={titleBlack} titleRed={titleRed} first={first} last={last}>
      <ScheduleDayTabs
        days={days}
        renderDay={(day) => <SessionDayTable day={day} columnLabels={columnLabels} />}
      />
    </GuardianExpoSection>
  )
}

function SessionDayTable({ day, columnLabels }) {
  return (
    <div className="self-stretch">
      <div className="self-stretch overflow-hidden" style={{ borderRadius: 8, outline: '1px solid rgba(110,98,91,0.08)' }}>
        <div className="flex items-center self-stretch" style={{ height: 30, background: '#BC313D', borderBottom: '1px solid rgba(110,98,91,0.08)' }}>
          <div className="flex-1 flex items-center justify-center self-stretch">
            <span style={{ color: 'white', fontFamily: 'Noto Sans TC', fontSize: 13, fontWeight: 400, lineHeight: '19.5px' }}>{columnLabels.session}</span>
          </div>
          <div className="flex-1 flex items-center justify-center self-stretch" style={{ borderLeft: '1px solid rgba(110,98,91,0.08)' }}>
            <span style={{ color: 'white', fontFamily: 'Noto Sans TC', fontSize: 13, fontWeight: 400, lineHeight: '19.5px' }}>{columnLabels.time}</span>
          </div>
        </div>

        {day.sessions.map((session, idx) => (
          <div
            key={idx}
            className="flex items-center self-stretch"
            style={{
              height: 35,
              background: idx % 2 === 1 ? 'rgba(188,49,61,0.04)' : 'transparent',
              borderBottom: idx < day.sessions.length - 1 ? '1px solid rgba(110,98,91,0.08)' : 'none',
            }}
          >
            <div className="flex-1 flex items-center justify-center self-stretch">
              <span style={{ color: '#6E625B', fontFamily: 'Noto Sans TC', fontSize: 18, fontWeight: 400, lineHeight: '27px' }}>{session.label}</span>
            </div>
            <div className="flex-1 flex items-center justify-center self-stretch" style={{ borderLeft: '1px solid rgba(110,98,91,0.08)' }}>
              <span style={{ color: '#6E625B', fontFamily: 'Noto Sans TC', fontSize: 18, fontWeight: 500, lineHeight: '27px' }}>{session.time}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
